/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Missed Appointments By Stage List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './MissedAppointmentsByStageListView';

export const mapStateToPropsMissedAppointmentsByStageList = mapStateToProps;
export const mapDispatchToPropsMissedAppointmentsByStageList =
  mapDispatchToProps;

export default connect(
  mapStateToPropsMissedAppointmentsByStageList,
  mapDispatchToPropsMissedAppointmentsByStageList
)(View);
